import React, { Suspense } from 'react';
import { Router } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import es_ES from 'antd/es/locale/es_ES';
import en_US from 'antd/es/locale/en_US';
import './i18n';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/en';

import store from '@state/store';
import history from '@utils/history';

import routes from '@routes';
import RenderRoutes from '@routes/components/RenderRoutes';

import './styles/main.less';
import 'swiper/swiper.less';

const App = () => {

  const { i18n } = useTranslation();
  dayjs.locale(i18n.language);

  return (
    <Suspense fallback={null}>
      <Provider store={store}>
        <Router history={history}>
          <LastLocationProvider>
            <ConfigProvider locale={i18n.language === 'en' ? en_US : es_ES}>
              <RenderRoutes routes={routes} />
            </ConfigProvider>
          </LastLocationProvider>
        </Router>
      </Provider>
    </Suspense>
  );

};

export default App;
